/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { usePlayFlag } from './../../components/topicScroll';

import './animation005.less';

interface IAnimation005Item {
  icon: string;
  text: string;
  title?: string | null;
}

const bgTemplate = ['#2E8DFE', '#FAAD14', '#E7444E', '#2E8DFE'];

const getBG = (feed: number) => bgTemplate[feed % bgTemplate.length];

interface IAnimation005Props {
  title?: string;
  items: IAnimation005Item[];
  style?: React.CSSProperties;
  className?: string;
  onCompleted?: () => void;
}

const Animation005: React.FunctionComponent<IAnimation005Props> = ({
  title,
  items,
  style,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 1) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      onCompleted && onCompleted();
    }
  };

  React.useEffect(() => {
    if (playFlag) {
      startPlay();
    }
  }, [playFlag]);

  return (
    <div
      ref={crrRef}
      className={`animation005 component ${className || ''}`}
      style={style}
    >
      {title && (
        <div
          className="animation008-title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      <div className="animation005-content">
        {items.map((itm: IAnimation005Item, idx: number) => (
          <div key={idx} className="animation005-contaner">
            {itm.title && (
              <div
                className={`animation005-header r${idx + 1}  animation ${
                  play >= idx + 1 ? 'fade-in' : ''
                }`}
                style={{
                  backgroundColor: getBG(idx),
                }}
              >
                <div
                  className="span"
                  dangerouslySetInnerHTML={{ __html: itm.title }}
                />
              </div>
            )}
            <div
              className={`animation005-item r${idx + 1} animation ${
                play >= idx + 1 ? 'fade-in' : ''
              }`}
            >
              <div className="icon">
                <img
                  src={require(`../../../../../assets/${itm.icon}`).default}
                  alt=""
                />
              </div>
              <div
                className="text"
                dangerouslySetInnerHTML={{ __html: itm.text }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Animation005;
